export enum Role {
  ClientManager = 'Company manager',
  StoreLocationManager = 'Store/location manager',
  HRManager = 'HR manager',
}
